module.exports = __webpack_public_path__ + "img/gaizao4.7f48e0bb.png";